<template>
  <el-dialog
    v-if="visible"
    v-bind="$attrs"
    :visible.sync="visible"
    width="62%"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="update-version">
      <div></div>
      <div class="version">
        <p>检测到新版本: {{ updateVersions.newVersion }}</p>
        <p>当前版本: {{ updateVersions.currVersion }}</p>
      </div>
    </div>
    <div class="update-content">
      <p>新版特性及优化：</p>
      <p v-for="(item, index) in featureList" :key="index">{{ item }}</p>
    </div>
    <div v-if="!isShowProgress" class="update-btn" @click="updateApp"></div>
    <div v-if="isShowProgress" class="update-progress">
      <div class="current-progress" :style="{ width: progress + '%' }">
        <span v-if="progress !== 0">{{ progress }}%</span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  isElectron,
  subscribeUpdateEvents,
  downloadUpdate,
  installUpdate
} from '@/utils/electron'

function parseReleaseNotes(notes) {
  if (!notes) return ['暂无更新说明']
  if (Array.isArray(notes)) return notes.filter(Boolean)
  return String(notes)
    .split(/\r?\n/)
    .map((line) => line.replace(/^[•*\d.\s-]+/, '').trim())
    .filter(Boolean)
}

export default {
  name: 'CheckUpdate',
  data() {
    return {
      visible: false,
      isShowProgress: false,
      progress: 0,
      downloading: false,
      unsubscribeUpdate: null,
      updateVersions: {
        newVersion: '',
        currVersion: '',
        feature: []
      }
    }
  },
  computed: {
    featureList() {
      const feature = this.updateVersions.feature
      return Array.isArray(feature) ? feature : []
    }
  },
  mounted() {
    this.bindElectronUpdate()
  },
  beforeDestroy() {
    this.unsubscribeUpdate?.()
  },
  methods: {
    bindElectronUpdate() {
      if (!isElectron()) return
      this.unsubscribeUpdate = subscribeUpdateEvents({
        onAvailable: (info) => {
          this.updateVersions = {
            newVersion: info.version || '',
            currVersion: info.currentVersion || '',
            feature: parseReleaseNotes(info.releaseNotes)
          }
          // 弹窗已开或正在下载：只刷新文案，不重置进度、不重复 open
          if (this.visible) return
          this.progress = 0
          this.open()
        },
        onDownloadProgress: (payload) => {
          this.progress = Math.min(100, Math.round(payload?.percent || 0))
          this.isShowProgress = true
        },
        onDownloaded: () => {
          this.progress = 100
          this.isShowProgress = true
          this.downloading = false
          installUpdate()
        },
        onError: (error) => {
          this.downloading = false
          this.isShowProgress = false
          this.progress = 0
          this.$message.error(error?.message || '检查更新失败')
        }
      })
    },
    async updateApp() {
      if (!isElectron() || this.downloading) return
      this.downloading = true
      this.isShowProgress = true
      this.progress = 0
      try {
        const res = await downloadUpdate()
        if (res && res.ok === false) {
          this.isShowProgress = false
          this.progress = 0
        }
      } catch (error) {
        this.isShowProgress = false
        this.progress = 0
        this.$message.error(error?.message || '下载更新失败')
      } finally {
        this.downloading = false
      }
    },
    open() {
      this.visible = true
      this.isShowProgress = false
    },
    close() {
      this.visible = false
      this.isShowProgress = false
      this.progress = 0
      this.downloading = false
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  background: url('@/assets/source/login/update-bg.png') no-repeat;
  background-size: 100% 100%;
  height: 800px;
  box-shadow: none;
  position: relative;
}
.update-version {
  display: flex;
  flex-direction: row;
  width: 80%;
  margin: 0px auto;
  margin-top: 100px;
  align-items: center;
  height: 200px;
  div {
    flex: 1;
  }
  .version {
    text-align: left;
    border-left: 1px dashed #ffdea8;
    padding-left: 63px;
    font-weight: 500;
    font-size: 24px;
    color: #813c00;
    line-height: 45px;
    letter-spacing: 4px;
  }
}
.update-btn {
  position: absolute;
  background: url('@/assets/source/login/update-btn.png') no-repeat;
  background-size: 100% 100%;
  width: 250px;
  height: 100px;
  bottom: 100px;
  left: 50%;
  transform: translate(-50%, 0);
  cursor: pointer;
}
.update-progress {
  background: url('@/assets/source/login/progress.png') no-repeat;
  background-size: 100% 100%;
  width: 65%;
  height: 70px;
  position: relative;
  bottom: -40px;
  left: 50%;
  transform: translate(-50%, 0);
  display: flex;
  align-items: center;
  .current-progress {
    position: absolute;
    transform: translate(0%, -50%);
    top: calc(50% - 4px);
    left: 8px;
    background: url('@/assets/source/login/progress-bg.png') no-repeat,
      linear-gradient(360deg, #2493dc 0%, #72eaf6 100%);
    background-size: 100% 100%;
    border-radius: 50px;
    max-width: 98%;
    height: 50px;
    line-height: 50px;
    text-align: right;
    font-weight: bold;
    font-size: 18px;
    color: #ffffff;
    letter-spacing: 7px;
    text-shadow: 0px 3px 3px rgba(30, 98, 188, 0.6);
    span {
      word-break: normal;
    }
  }
}
.update-content {
  width: 56%;
  margin: auto;
  height: 163px;
  overflow-y: scroll;
  background-color: #ffe2b4;
  padding: 20px 47px;
  border-radius: 24px;
  font-weight: 500;
  font-size: 25px;
  color: #813c00;
  line-height: 45px;
  letter-spacing: 6px;
  text-align: left;
  p {
    margin: 0;
  }
}
</style>
